import { S as c } from "./sections-api-service.smvSsykG.min.js";
import { p as o } from "./parse-html.C-hh7jJd.min.js";
class s extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    ((this.quickViewHolder = document.querySelector(
      ".js-dickies-quickview-content",
    )),
      (this.form = this.querySelector("form")),
      (this.button = this.querySelector("[data-dickies-quick-view-button]")),
      (this.handleClick = this.renderQuickView.bind(this)),
      (this.fetchSection = this.fetchSection.bind(this)),
      this.button.addEventListener("click", this.handleClick),
      this.button.addEventListener("mouseenter", this.fetchSection),
      this.button.addEventListener("touchstart", this.fetchSection)
    );
  }
  disconnectedCallback() {
    (this.button.removeEventListener("click", this.handleClick),
      this.button.removeEventListener("mouseenter", this.fetchSection),
      this.button.removeEventListener("touchstart", this.fetchSection));
  }

  async fetchSection() {
    const t = this.button.getAttribute("data-product-url");
    try {
      const e = t.includes("http")
        ? new URL(t)
        : new URL(`${window.location.origin}${t}`);
      await c.fetch(e, "dickies-render-quick-view");
    } catch (e) {
      console.error("Error rendering quick view:", e);
    }
  }
  async renderQuickView(t) {
    t.preventDefault();
    const e = this.button.getAttribute("data-product-url");
    try {
      const i = e.includes("http")
          ? new URL(e)
          : new URL(`${window.location.origin}${e}`),
        n = await c.fetch(i, "dickies-render-quick-view"),
        r = o(n, ".js-quick-view-markup");
      ((this.quickViewHolder.innerHTML = r.innerHTML),
        document.dispatchEvent(new CustomEvent("theme:quick-view:init")));
    } catch (i) {
      console.error("Error rendering quick view:", i);
    }
  }
}
const a = () => {
  customElements.get("dickies-quick-view") ||
    customElements.define("dickies-quick-view", s);
};
export { a as default };
